import * as React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';

import { IconType, SvgIcon } from '../General/SvgIcon';

export interface CartStepProps {
  title: string;
  stepNumber: number;
  stepUrl: string;
  status: string;
  onStepClick: (step: number) => void;
  isDelimeter?: boolean;
}

const IconWrapper = styled.div`
  height: ${rem(48)};
  width: ${rem(48)};
  border-radius: 50%;
  margin-right: ${rem(8)};
  text-decoration: none;

  ${({ theme }) => theme.mediab.m580`
    margin-right: 0;
  `};
`;

const DesktopIconWrapper = styled(IconWrapper)`
  ${({ theme }) => theme.mediab.m580`
   display: none;
  `};
`;

const MobileIconWrapper = styled(IconWrapper)`
  display: none;
  ${({ theme }) => theme.mediab.m580`
    display: flex;
    justify-content: center;
    align-items: center;
  `};
`;

const NumberWrapper: any = styled.span`
  height: ${rem(48)};
  width: ${rem(48)};
  border-radius: 50%;
  margin-right: ${rem(8)};
  text-align: center;
  font-weight: 700;
  border-width: ${rem(2)};
  border-style: solid;
  transition: color 0.2s ease, border-color 0.2s ease;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(19)};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.cartStep.current};

  ${(props: any) => {
    const { theme, status } = props;
    switch (status) {
      case 'selected': {
        return css`
          border-color: ${theme.cartStep.current};
          background-color: ${theme.cartStep.current};
          color: ${theme.colors.white};
        `;
      }
      case 'done': {
        return css`
          border-color: ${theme.cartStep.done};
        `;
      }
      default: {
        return css`
          border-color: ${theme.cartStep.borderDefault};
        `;
      }
    }
  }};

  ${({ theme }) => theme.mediab.l925`
    margin-right: 0;
  `};
`;

const TitleWrapper: any = styled.span`
  margin-left: ${rem(16)};
  font-size: ${rem(16)};
  white-space: nowrap;
  transition: color 0.2s ease;
  font-weight: 500;
  line-height: ${rem(24)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};

  ${({ theme }) => theme.mediab.l925`
    margin-top: ${rem(8)};
    margin-left: 0;
  `};

  ${({ theme }) => theme.mediab.m580`
    margin: 0;
    margin-top: ${rem(8)};
    white-space: initial;
    text-align: center;
    display: block;
    font-size: ${theme.cartStep.mobileFontSize};
    font-family: ${theme.font.primary};
    color: ${theme.colors.textPrimary};
    line-height: ${rem(18)};
    font-weight: 400;
    max-width: ${rem(100)};
  `};
`;

const Wrapper: any = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  text-decoration: none;
  color: ${(props: any) =>
    props.selected ? props.theme.colors.btnPrimary : '#aaaaaa'};
  margin: 0 ${rem(16)};
  padding-bottom: ${(props: any) =>
    props.theme.cart.cartStep.default.paddingBottom || `${rem(30)}`};

  ${(props: any) => {
    const { theme } = props;
    return css`
      &:hover {
        cursor: pointer;
      }

      &:hover ${TitleWrapper} {
        color: ${theme.cartStep.text};
        opacity: 0.8;
      }

      &:hover ${IconWrapper} {
        opacity: 0.8;
      }
    `;
  }};

  ${({ theme }) => theme.mediab.l925`
    flex-direction: column;
    margin: 0 ${rem(15)}
  `};

  ${({ theme }) => theme.mediab.m580`
    margin: 0;
  `};
`;

function CartStep({ status, title, stepNumber, onStepClick }: CartStepProps) {
  const Image =
    status === 'done' ? (
      <>
        <DesktopIconWrapper>
          <SvgIcon
            icon={IconType.cartDone}
            title={`${title}-Vyplnené`}
            alt={`${title}-Vyplnené`}
            cursor={'pointer'}
            viewBox="0 0 45 45"
            marginRight={8}
            width={48}
            height={48}
            fill={'#A5BBA2'}
          />
        </DesktopIconWrapper>
        <MobileIconWrapper>
          <SvgIcon
            icon={IconType.cartDone}
            title={`${title}-Vyplnené`}
            alt={`${title}-Vyplnené`}
            cursor={'pointer'}
            viewBox="0 0 45 45"
            marginRight={0}
            width={48}
            height={48}
            fill={'#A5BBA2'}
          />
        </MobileIconWrapper>
      </>
    ) : (
      <NumberWrapper status={status}>{stepNumber}</NumberWrapper>
    );

  return (
    <Wrapper
      // tslint:disable-next-line:jsx-no-lambda
      onClick={() => onStepClick(stepNumber)}
    >
      {Image}
      <TitleWrapper status={status}>{title}</TitleWrapper>
    </Wrapper>
  );
}

export { CartStep };
